import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'snack-bar-message-success',
  templateUrl: './snack-bar-message-success.component.html',
  styleUrl: './snack-bar-message-success.component.scss',
  standalone: false,
})
export class SnackBarMessageSuccessComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public readonly data: string,
    private readonly snackBarRef: MatSnackBarRef<string>,
  ) {}

  onClose() {
    this.snackBarRef.dismissWithAction();
  }
}
